import spritestandard from '../../../assets/icons/standard-sprite/svg/symbols.svg'
import spriteutility from '../../../assets/icons/utility-sprite/svg/symbols.svg'
import spriteaction from '../../../assets/icons/action-sprite/svg/symbols.svg'
import spritecustom from '../../../assets/icons/custom-sprite/svg/symbols.svg'
import spritedoctype from '../../../assets/icons/doctype-sprite/svg/symbols.svg'
import spritepicsa from '../../../assets/icons/picsaos-sprite/svg/symbols.svg'

export let getSprite = function(sprite) {
  switch (sprite) {
    case 'utility' :
      return spriteutility
    case 'standard':
      return spritestandard
    case 'action':
      return spriteaction
    case 'doctype':
      return spritedoctype
    case 'picsaos':
      return spritepicsa
    default :
      return spritecustom
 }
}



// WEBPACK FOOTER //
// ./src/utils/icon/sprite/index.js